<div>
    <div class="box">
      <div class="drag-handle" cdkDragHandle>
        <button (click)="onClickIntersect()" class="circle-intersect-button" id="vinSelectorTool" matTooltip="Seleccionar Vines" matTooltipPosition="above">
            <div class="button-icon">
              <img *ngIf="this.toolCarsSelectorservice.isCarSelectionToolVisible" [src]="'icon_vins.svg' | findUrl" class="img-button">
              <img *ngIf="!this.toolCarsSelectorservice.isCarSelectionToolVisible" [src]="'icon_vins_gris.svg' | findUrl" class="img-button">
            </div>
        </button>
      </div>
      <div [@mostrarLista]="this.toolCarsSelectorservice.isCarSelectionToolVisible ? 'visible' : 'hidden'" class="vin-list">
        <div class="vin-tool-title">
          <h2>Vines</h2>
          <!-- <mat-icon class="close-button" matTooltip="Cerrar" aria-hidden="false"  fontIcon="cancel" (click)="onClickIntersect()"></mat-icon> -->

        </div>
          <div [ngClass]="{'intersect-container-availability': isAvailabilityButton}" class="intersect-container" (mousedown)="$event.stopPropagation()" (mouseup)="$event.stopPropagation()">
            <div *ngFor="let feature of intersectedFeatures" class="vin-item">
              <label class="img-container">
                <img [src]="'icon_auto_vin_gris.svg' | findUrl" class="img-button">
              </label>
              <span>{{ feature.properties._Id }}</span>
            </div>
          </div>
          <div *ngIf="isAvailabilityButton" class="buttonContainer">
            <button mat-button class="btnAccept" style="color: white; height: 20px;" (click)="submitAvailability()">Apartar</button>
          </div>
      </div>
    </div>
  </div>